import { render, staticRenderFns } from "./PosBadgeImport.vue?vue&type=template&id=22d40d10&scoped=true"
import script from "./PosBadgeImport.vue?vue&type=script&lang=js"
export * from "./PosBadgeImport.vue?vue&type=script&lang=js"
import style0 from "./PosBadgeImport.vue?vue&type=style&index=0&id=22d40d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d40d10",
  null
  
)

export default component.exports